import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import de from './locales/de.json';
import enKiAgentur from './locales/en.kiAgenturArticle.json';
import deKiAgentur from './locales/de.kiAgenturArticle.json';
import enGoogleAds from './locales/en.googleAdsAgenturArticle.json';
import deGoogleAds from './locales/de.googleAdsAgenturArticle.json';
import enLocalSeo from './locales/en.localSeoArticle.json';
import deLocalSeo from './locales/de.localSeoArticle.json';
import enOnlineMarketing from './locales/en.onlineMarketingArticle.json';
import deOnlineMarketing from './locales/de.onlineMarketingArticle.json';
import enPaidAdvertising from './locales/en.paidAdvertisingArticle.json';
import dePaidAdvertising from './locales/de.paidAdvertisingArticle.json';
import enPerformanceMarketing from './locales/en.performanceMarketingArticle.json';
import dePerformanceMarketing from './locales/de.performanceMarketingArticle.json';
import enSeoAgentur from './locales/en.seoAgenturArticle.json';
import deSeoAgentur from './locales/de.seoAgenturArticle.json';
import enWebdesign from './locales/en.webdesignArticle.json';
import deWebdesign from './locales/de.webdesignArticle.json';
import enBookingSystem from './locales/en.bookingSystemArticle.json';
import deBookingSystem from './locales/de.bookingSystemArticle.json';
import enEmailMarketing from './locales/en.emailMarketingArticle.json';
import deEmailMarketing from './locales/de.emailMarketingArticle.json';
import enReputation from './locales/en.reputationManagementArticle.json';
import deReputation from './locales/de.reputationManagementArticle.json';


// Initialize i18next with standard plugins first
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
        kiAgenturArticle: enKiAgentur,
        googleAdsAgenturArticle: enGoogleAds,
        localSeoArticle: enLocalSeo,
        onlineMarketingArticle: enOnlineMarketing,
        paidAdvertisingArticle: enPaidAdvertising,
        performanceMarketingArticle: enPerformanceMarketing,
        seoAgenturArticle: enSeoAgentur,
        webdesignArticle: enWebdesign,
        bookingSystemArticle: enBookingSystem,
        emailMarketingArticle: enEmailMarketing,
        reputationManagementArticle: enReputation,
      },
      de: {
        translation: de,
        kiAgenturArticle: deKiAgentur,
        googleAdsAgenturArticle: deGoogleAds,
        localSeoArticle: deLocalSeo,
        onlineMarketingArticle: deOnlineMarketing,
        paidAdvertisingArticle: dePaidAdvertising,
        performanceMarketingArticle: dePerformanceMarketing,
        seoAgenturArticle: deSeoAgentur,
        webdesignArticle: deWebdesign,
        bookingSystemArticle: deBookingSystem,
        emailMarketingArticle: deEmailMarketing,
        reputationManagementArticle: deReputation,
      },
    },
    fallbackLng: 'de',
    ns: [
      'translation',
      'kiAgenturArticle',
      'googleAdsAgenturArticle',
      'localSeoArticle',
      'onlineMarketingArticle',
      'paidAdvertisingArticle',
      'performanceMarketingArticle',
      'seoAgenturArticle',
      'webdesignArticle',
      'bookingSystemArticle',
      'emailMarketingArticle',
      'reputationManagementArticle'
    ],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    detection: { 
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
